function stripeTranslate() {
  return (lineItemDescription, language) => {
    if (language === "es") {
      return lineItemDescription
        .replace("Unused time on", "Tiempo no utilizado en")
        .replace("Remaining time on", "Tiempo restante en")
        .replace("with", "con")
        .replace("off", "descontado")
        .replace("after", "después")
        .replace("at ", "")
        .replace("month", "mes")
        .replace("year", "año")
        .replace(" Jan ", " Ene ")
        .replace(" Aug ", "Ago")
        .replace(" Dec ", " Dic ");
    } else {
      return lineItemDescription.replace("Usuarios Adicionales", "Extra Users");
    }
  };
}

export default stripeTranslate;
